<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目">
					<el-select v-model="filters.projectId"   @change="getDevices" style="max-width:170px" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="编码">
					<el-select v-model="filters.deviceId" filterable>
						<el-option label=" " value="0" key="0"></el-option>
						<el-option
							v-for="item in devices"
							:label="item.mnCode"
							:value="item.deviceId" :key="item.deviceId">
						</el-option>
					</el-select>
				</el-form-item>
             	<el-form-item label="用户">
					<el-select v-model="filters.userId" filterable>
						<el-option label=" " value="0" key="0"></el-option>
						<el-option
							v-for="item in users"
							:label="item.name"
							:value="item.userId" :key="item.userId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="ReviewSets" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" border :height="formHeight"  size="mini" >
			<el-table-column type="selection">
			</el-table-column>
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="名称" >
			</el-table-column>
			<el-table-column prop="mnCode" label="设备编码" >
			</el-table-column>
			<el-table-column prop="userName" label="审核人">
			</el-table-column>
			<el-table-column prop="wayname" label="审核方式" >
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<drop-button   @select-type="batchRemove"  :disabled="this.sels.length===0" btnCon="批量删除">  </drop-button>
			<edit-button   @select-type="handleEdit"  :disabled="this.sels.length===0" btnCon="批量修改">  </edit-button>
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;"
			:page-sizes="[20,50,100,200]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面 角色修改、添加-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :inline="true" :model="formUser"  size="normal" id="formSet">
				<el-form-item>
					<el-select v-model="formUser.userid" filterable  placeholder="请选择审核人">
						<el-option
							v-for="item in users"
							:label="item.name"
							:value="item.userId" :key="item.userId">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
					<el-select v-model="formUser.reviewWayid" placeholder="请选择审核方式">
						<el-option
							v-for="item in reviewWays"
							:label="item.name"
							:value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<el-form :inline="true" :model="filtersForm"  size="mini"  v-show="formUpdateVisible">
				<el-form-item>
					<el-input v-model="filtersForm.mnCode" placeholder="设备编码"></el-input>
				</el-form-item>
                <el-form-item>
					<el-select v-model="filtersForm.ProjectId" placeholder="请选择项目" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getDeviceForm()">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="devicesForm" highlight-current-row v-loading="listLoading" @selection-change="selsFormChange" style="width: 100%;" border height="300px" size="mini"  ref="devicesForm"  v-show="formUpdateVisible">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" label="序号">
				</el-table-column>
				<el-table-column prop="name" label="名称" sortable>
				</el-table-column>
				<el-table-column prop="mnCode" label="设备编码"  sortable>
				</el-table-column>
				<el-table-column prop="projectName" label="项目"   sortable>
				</el-table-column>
			</el-table>

			<el-col :span="24" class="toolbar" v-show="formUpdateVisible">
				<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleFormCurrentChange" :page-size="pageSizeForm" :total="totalForm" style="float:right;"
				:page-sizes="[20,50,100,200]"   @size-change="handleFormSizeChange" :current-page.sync="pageForm">
				</el-pagination>
			</el-col>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getDevicesByProjectId,getUsers,getReviewSetList,deleteReviewSets,getDeviceList,getReviewWay,addReviewSet,updateReviewSet ,getProjects} from '../../api/api';

	import myButton from '../../components/myButton/index.vue'
	import DropButton from '../../components/myButton/DropButton.vue'
	import EditButton from '../../components/myButton/EditButton.vue'

	export default {
	components: { myButton,DropButton,EditButton},
		data() {
			return {
				filters: {
					projectId:'',
                    deviceId: '',
                    userId: ''
				},
				filtersForm: {
                    mnCode: '',
                    ProjectId:''
				},
				formUser:{
					userid:"",
					reviewWayid:""
				},
                users: [],
				devices:[],
				projects:[],
				devicesForm:[],
				ReviewSets:[],
				reviewWays:[],
				total: 0,
				totalForm:0,
				page:1,
				pageSize:50,
				pageForm:1,
				pageSizeForm:50,
				listLoading: false,
				sels: [],//列表选中列
				selsDev:[],
				type:'新增',
				formHeight:0,

				formVisible: false,//修改界面是否显示
				formUpdateVisible:false,//添加界面表格是否显示
				loading: false,
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getReviewSetList();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getReviewSetList();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getReviewSetList();
			},
			handleFormCurrentChange(val) {
				this.pageForm=val;
				this.getDeviceForm();
			},
			handleFormSizeChange(val){
				this.pageSizeForm=val;
				this.getDeviceForm();
			},
			//查询项目信息
			getProjects() {
				getProjects().then((res) => {
					this.projects = res.data.data;
				});
			},
			//获取设备列表
			getDevices() {
				let para = {
                    projectId: this.filters.projectId
                };
				getDevicesByProjectId(para).then((res) => {
					this.devices = res.data.data;
				});
			},
			//获取数据列表
			getDeviceForm() {
				let para = {
                    page: this.pageForm,
                    pageSize:this.pageSizeForm,
                    mnCode: this.filtersForm.mnCode,
					projectId:this.filtersForm.ProjectId
				};
                this.listLoading = true;
				getDeviceList(para).then((res) => {
                    this.listLoading = false;
					this.totalForm = res.data.data.total;
					this.devicesForm = res.data.data.records;
				});
			},
			//获取用户列表
			getUsers() {
				getUsers().then((res) => {
					this.users = res.data.data;
				});
            },
			//获取用户列表
			getReviewSetList() {
				let para = {
					page: this.page,
					pageSize:this.pageSize,
					deviceId: this.filters.deviceId,
					projectId: this.filters.projectId,
                    userId: this.filters.userId
				};
				this.listLoading = true;
				getReviewSetList(para).then((res) => {
					
					this.total = res.data.data.total;
					this.ReviewSets = res.data.data.data;
					this.listLoading = false;

				});
            },
            //获取设备等级
			getReviewWay() {
				this.listLoading = true;
				getReviewWay().then((res) => {
                    this.reviewWays = res.data.data;
					this.listLoading = false;
				});
            },
			//显示修改界面
			handleEdit: function (row) {
				this.formVisible = true;
                this.formUpdateVisible=false;
				if(this.reviewWays.length==0){
					this.getReviewWay();
				}
				this.type='修改';
				this.formUser = {
					userid: "",
					reviewWayid:""
				};
			},
			//显示新增界面
			handleAdd: function () {
				if(this.devicesForm.length==0){
					this.getDeviceForm();
				}
				if(this.reviewWays.length==0){
					this.getReviewWay();
				}
				this.formVisible = true;
				this.formUpdateVisible=true;
				if( this.$refs.devicesForm!=undefined){
               		this.$refs.devicesForm.clearSelection();
				}
				this.type='新增';
				this.formUser = {
					userid: "",
					reviewWayid:""
				};
				this.filtersForm={
					mnCode: '',
                    ProjectId:''
				};
			},
			//Form表单提交
            submitData:function(){
				if(this.formUser.reviewWayid==""){
					this.$message({
						message: "未选择等级",
						type: 'error'
					})
					return;
				}
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//修改
			editSubmit: function (idnex,row) {
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					var ids = this.sels.map(item => item.id).toString();
					let para = {
						ids:ids,
						userId:this.formUser.userid,
						reviewWayid:this.formUser.reviewWayid,
					};
					this.loading = true;
					updateReviewSet(para).then((res) => {
						this.loading = false;
						let resData = res.data;
						if (resData.code != 200) {
							this.$message({
							message: resData.msg,
							type: 'error'
						})}else{
							this.$message({
								message: '修改成功',
								type: 'success'
							});
						}
						this.formVisible = false;
						this.getReviewSetList();
					});
				});
			},
			//新增
			addSubmit: function () {
				this.$confirm('确认提交吗？', '提示', {}).then(() => {
					this.loading = true;
					var ids = this.selsDev.map(item => item.deviceId).toString();
					let para = {
						deviceIds:ids,
						userId:this.formUser.userid,
						reviewWayid:this.formUser.reviewWayid,
					};
					addReviewSet(para).then((res) => {
						this.loading = false;
						let resData = res.data;
						if (resData.code != 200) {
							this.$message({
							message: resData.msg,
							type: 'error'
						})}else{
							this.$message({
								message: '添加成功',
								type: 'success'
							});
						}
						this.formVisible = false;
						this.getReviewSetList();
					});
				});
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			selsFormChange:function(sels){
				this.selsDev = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = { ids: ids };
					deleteReviewSets(para).then((res) => {
						this.listLoading = false;
						let resData = res.data;
						if (resData.code != 200) {
							this.$message({
							message: "删除失败",
							type: 'error'
						})}else{
							this.$message({
								message: '删除成功',
								type: 'success'
							});
						}
						this.getReviewSetList();
					});
				}).catch(() => {

				});
			},
			//取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			var timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getProjects();
			this.getUsers();
			this.getReviewSetList();
		}
	}

</script>

<style scoped>
	.containerRole{
		display: flex;
	}
	.containerRole .block {
		-ms-flex: 1;
		flex: 1;
		padding: 0 24px;
	}
	.containerRole .title{
		font-weight: bold;
		margin-bottom: 10px;
	}
	#formSet{
		position: absolute;
		left: 2%;
		bottom: 0%;
	}
</style>


// WEBPACK FOOTER //
// ReviewSet.vue?07229cfe